var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var baseTokens = require('./tokens').baseTokens;
import { BaseSparqlParser } from './BaseSparqlParser';
import { Parser } from 'chevrotain';
var W3SpecSparqlParser = /** @class */ (function (_super) {
    __extends(W3SpecSparqlParser, _super);
    function W3SpecSparqlParser(options) {
        var _this = _super.call(this, options, baseTokens) || this;
        Parser.performSelfAnalysis(_this);
        return _this;
    }
    return W3SpecSparqlParser;
}(BaseSparqlParser));
export { W3SpecSparqlParser };
